import React, { useEffect, useState } from 'react';
import { get } from 'lodash';

import { Button, Input, Textarea } from '../../kaya';
import userStore from '../../zustand/user.store';
import { authHelpers, generalHelpers } from '../../helpers';

import styles from './ContactUs.module.scss';
const ContactUs = () => {
  const { user } = userStore((state) => ({
    user: state.user,
  }));

  const [formValues, setFormValues] = useState({
    username: '',
    name: '',
    email: '',
    phone_no: '',
    issue: '',
  });

  const [err, setErr] = useState({
    // username: '',
    // name: '',
    // email: '',
    // phone: '',
    issue: '',
  });
  const [loading, setLoading] = useState(false);

  const handleChange = (id) => (value) => {
    if (typeof id !== 'object') {
      setFormValues({
        ...formValues,
        [id]: value,
      });
      setErr({
        ...err,
        [id]: '',
      });
    } else {
      setFormValues({
        ...formValues,
        ...id,
      });
      setErr({
        ...err,
        ...id,
      });
    }
  };

  const disableButton = () => {
    if (
      formValues.username === user.username &&
      formValues.name === user.first_name + ' ' + user.last_name &&
      formValues.email === user.email &&
      formValues.phone_no === get(user, 'phone_no', '').toString() &&
      formValues.issue === ''
    ) {
      return true;
    }
    return false;
  };

  const handleSubmit = () => {
    const error = {
      issue: authHelpers.validateDescription(formValues.issue),
    };
    if (!generalHelpers.isEmptyErrors(error)) {
      setErr(error);
      return;
    }
    setLoading(true);
    //api call
    setLoading(false);
  };

  useEffect(() => {
    setFormValues({
      ...formValues,
      username: user.username,
      name: user.first_name + ' ' + user.last_name,
      email: user.email,
      // phone no is string in user store then store as it is else convert to string
      phone_no: get(user, 'phone_no', '').toString(),

      issue: '',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [user]);

  return (
    <div className={styles.ContactUs}>
      <div className={styles.box}>
        <div className={styles.labelWithInput}>
          <p className={styles.label}>Username</p>
          <Input
            placeholder='username'
            containerClassName={styles.input}
            onChange={handleChange('username')}
            id='username'
            errors={err}
            value={formValues.username}
            disabled
          />
        </div>
        <div className={styles.labelWithInput}>
          <p className={styles.label}>Name</p>
          <Input
            placeholder='name'
            containerClassName={styles.input}
            onChange={handleChange('name')}
            id='name'
            errors={err}
            value={formValues.name}
            disabled
          />
        </div>
        <div className={styles.labelWithInput}>
          <p className={styles.label}>Email</p>
          <Input
            placeholder='email'
            containerClassName={styles.input}
            onChange={handleChange('email')}
            id='email'
            errors={err}
            value={formValues.email}
            disabled
          />
        </div>
        <div className={styles.labelWithInput}>
          <p className={styles.label}>Phone No.</p>
          <Input
            placeholder='Phone no'
            containerClassName={styles.input}
            onChange={handleChange('phone_no')}
            id='phone_no'
            errors={err}
            value={formValues.phone_no}
            disabled
          />
        </div>
        <div className={styles.labelWithInput1}>
          <p className={styles.label}>Issue</p>
          <Textarea
            placeHolder='Issue'
            onChange={handleChange('issue')}
            error={err.issue}
            className={styles.input1}
            value={formValues.issue}
          />
        </div>
        <div className={styles.btnContainer}>
          <Button
            onClick={handleSubmit}
            className={styles.btn}
            type='Primary'
            disabled={disableButton()}
            isLoading={loading}>
            Send
          </Button>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
